const o = (i) => ({ sizes: {
  xsmall: {
    height: i * 2,
    paddingHorizontal: i * 1.375,
    textVariant: "ub3-bold",
    borderWidth: 1,
    iconSize: i,
    iconPadding: i * 0.25,
    loaderSize: i * 1.25
  },
  small: {
    height: i * 2.5,
    paddingHorizontal: i * 1.625,
    textVariant: "ub2-bold",
    borderWidth: 1,
    iconSize: i * 1.25,
    iconPadding: i * 0.375,
    loaderSize: i * 1.5
  },
  regular: {
    height: i * 3,
    paddingHorizontal: i * 1.875,
    textVariant: "ub1-bold",
    borderWidth: 1,
    iconSize: i * 1.5,
    iconPadding: i * 0.5,
    loaderSize: i * 1.75
  },
  medium: {
    height: i * 3.5,
    paddingHorizontal: i * 2.125,
    textVariant: "ub1-bold",
    borderWidth: 1.5,
    iconSize: i * 1.5,
    iconPadding: i * 0.5,
    loaderSize: i * 2
  },
  large: {
    height: i * 4,
    paddingHorizontal: i * 2.375,
    textVariant: "ub1-bold",
    borderWidth: 2,
    iconSize: i * 1.5,
    iconPadding: i * 0.5,
    loaderSize: i * 2.25
  }
}, variants: {
  primary: {
    backgroundColorName: {
      inactive: "YELLOW_4",
      active: "BLACK",
      disabled: "GREY_3"
    },
    colorName: {
      inactive: "BLACK",
      active: "WHITE",
      disabled: "BLACK"
    },
    borderColorName: {
      inactive: "BLACK",
      active: "BLACK",
      disabled: "GREY_3"
    }
  },
  secondary: {
    backgroundColorName: {
      inactive: "WHITE",
      active: "BLACK",
      disabled: "GREY_3"
    },
    colorName: {
      inactive: "BLACK",
      active: "WHITE",
      disabled: "BLACK"
    },
    borderColorName: {
      inactive: "BLACK",
      active: "BLACK",
      disabled: "GREY_3"
    }
  },
  tertiary: {
    backgroundColorName: {
      inactive: "WHITE",
      active: "RED",
      disabled: "GREY_3"
    },
    colorName: {
      inactive: "RED",
      active: "WHITE",
      disabled: "BLACK"
    },
    borderColorName: {
      inactive: "RED",
      active: "RED",
      disabled: "GREY_3"
    }
  }
  // 'yellow': {
  //   backgroundColorName: {
  //     inactive: 'YELLOW_4',
  //     active: 'BLACK_4',
  //     disabled: 'BLACK_T_35',
  //   },
  //   borderColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'BLACK_T_35',
  //   },
  //   colorName: {
  //     inactive: 'BLACK_4',
  //     active: 'WHITE_4',
  //     disabled: 'BLACK_T_35',
  //   },
  // },
  // 'yellow-dark': {
  //   backgroundColorName: {
  //     inactive: 'YELLOW_4',
  //     active: 'WHITE_4',
  //     disabled: 'WHITE_T_40',
  //   },
  //   borderColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'WHITE_T_40',
  //   },
  //   colorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'WHITE_T_40',
  //   },
  // },
  // 'white': {
  //   backgroundColorName: {
  //     inactive: 'WHITE_1',
  //     active: 'BLACK_T_35',
  //     disabled: 'BLACK_T_35',
  //   },
  //   borderColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'BLACK_T_35',
  //   },
  //   colorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'BLACK_T_35',
  //   },
  // },
  // 'white-dark': {
  //   backgroundColorName: {
  //     inactive: 'WHITE_4',
  //     active: 'WHITE_T_70',
  //     disabled: 'WHITE_T_40',
  //   },
  //   borderColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'WHITE_T_40',
  //   },
  //   colorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'WHITE_T_40',
  //   },
  // },
  // 'black': {
  //   backgroundColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_T_60',
  //     disabled: 'BLACK_T_35',
  //   },
  //   borderColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'BLACK_4',
  //     disabled: 'BLACK_T_35',
  //   },
  //   colorName: {
  //     inactive: 'WHITE_4',
  //     active: 'WHITE_4',
  //     disabled: 'BLACK_T_35',
  //   },
  // },
  // 'black-dark': {
  //   backgroundColorName: {
  //     inactive: 'BLACK_4',
  //     active: 'WHITE_T_40',
  //     disabled: 'WHITE_T_40',
  //   },
  //   borderColorName: {
  //     inactive: 'WHITE_4',
  //     active: 'WHITE_4',
  //     disabled: 'WHITE_T_40',
  //   },
  //   colorName: {
  //     inactive: 'WHITE_4',
  //     active: 'WHITE_4',
  //     disabled: 'WHITE_T_40',
  //   },
  // },
} });
export {
  o as default
};
//# sourceMappingURL=button.js.map
